module.exports = __webpack_public_path__ + "img/scope-and-mask-purple.386c6dff.png";